/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Accreditation_ConfirmInputs */

const en_welcome_accreditation_confirm = /** @type {(inputs: Welcome_Accreditation_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I <b>confirm</b>, I meet at least one of the requirements of an accredited investor`)
};

/**
* | output |
* | --- |
* | "I <b>confirm</b>, I meet at least one of the requirements of an accredited investor" |
*
* @param {Welcome_Accreditation_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const welcome_accreditation_confirm = /** @type {((inputs?: Welcome_Accreditation_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Accreditation_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_accreditation_confirm(inputs)
});